module.exports = __webpack_public_path__ + "img/blue-oasis.4c4fa971.jpg";